import React, {useState} from 'react';
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {InputText} from "primereact/inputtext";
import {useTranslate} from "../../../system/useTranslate";
import {useSelector} from "react-redux";
import {DataView} from "primereact/dataview";
import Avatar from "../../../system/components/avatar";
import {Button} from "primereact/button";
import {Checkbox} from "primereact/checkbox";
import {useMountEffect} from "primereact/hooks";
import DatatableEmptyMessage from "../../../system/components/datatable-empty-message";

function MultiSelectGoals({value, onCancel, onConfirm, onChange, options}) {

    const [searchText, setSearchText] = useState("");
    const translate = useTranslate();
    const [selectedGoals, setSelectedGoals] = useState([])

    useMountEffect(()=>{
        
        setSelectedGoals(value)
    })

    const updateSelectedGoals = (goalData)=>{

        let _selectedGoals = [...selectedGoals];
        if (_selectedGoals.find(p=>p.id===goalData.id)){
            _selectedGoals = _selectedGoals.filter(p=>p.id!==goalData.id);
            onChange?.({goalData, status:'removed'});
        }
        else{
            _selectedGoals = [...selectedGoals, goalData];
            onChange?.({goalData, status:'added'});
        }
        setSelectedGoals(_selectedGoals);

    }

    const ItemTemplate = (data)=>{

        return(
            <div className="w-full flex align-items-center justify-content-between py-1 text-xs">
               <div className="flex gap-2 align-items-center">
                   <span>{data?.title}</span>
               </div>
                <Checkbox checked={!!selectedGoals?.find(e=>e.id===data.id)} onChange={(e)=>{updateSelectedGoals(data)}}/>
            </div>
        )
    }

    return (
        <div className="w-14rem flex flex-column p-2 gap-2">
            <div className="border-bottom-1 border-100">
                <IconField dir="rtl">
                    <InputIcon className="pi pi-search"/>
                    <InputText className="w-full text-xs py-2" placeholder={translate("search-goals-placeholder")} value={searchText} onChange={(e)=>{setSearchText(e.target.value)}}/>
                </IconField>
            </div>
            <DataView emptyMessage={<DatatableEmptyMessage/>} layout="list" itemTemplate={ItemTemplate} value={options?.filter(e=>e?.title?.includes(searchText))}/>
            {(onCancel||onConfirm)&&(
                <div className="flex align-items-center justify-content-between">
                    {onCancel&&<Button onClick={()=>{onCancel?.()}} label={translate("cancel")} className="p-2 text-xs shadow-none border-none p-button-text"/>}
                    {onConfirm&&<Button onClick={()=>{onConfirm?.(selectedGoals)}} label={translate("confirm-add")} className="p-2 text-xs shadow-none border-none"/>}
                </div>
            )}
        </div>
    );
}

export default MultiSelectGoals;